import { useNavigate } from "react-router-dom";
import ETFQuizContent from "@/components/ETFQuizContent";

const ETFQuiz = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-slate-50">
      <ETFQuizContent onBack={() => navigate("/")} />
    </div>
  );
};

export default ETFQuiz;
